<template>
  <router-view />
</template>

<script>

export default {
  name: 'TaskWrapper'
}
</script>
